<app-loading-overlay [isLoading]="!!isLoading"></app-loading-overlay>
<div nz-row>
  <div nz-col nzSpan="8">
    <span class="tab-title">Dashboard</span>
  </div>
  <div nz-col nzOffset="12" nzSpan="4">
    <button nz-button nzSize="large" class="green-btn" (click)="openCreateDashboardModal()">
      <span>Create Dashboard</span>
    </button>
  </div>
</div>

<div class="dashboard-panel">
  <nz-table
    #dashboardsTable
    [nzData]="dashboards"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
    [nzScroll]="{ x: '98.75rem', y: 'calc(100vh - 18rem)' }"
    [nzNoResult]="noDataTemplate"
    nzSize="middle"
    nzBordered
  >
    <thead>
      <tr>
        <ng-container *ngFor="let header of dashHeaders; trackBy: trackByHeader">
          <th
            *ngIf="header.sortDirections; else nonSortableHeader"
            [nzSortDirections]="header.sortDirections"
            [nzSortOrder]="header.sortOrder"
            [nzSortFn]="header.sortFn"
            [nzWidth]="header.width"
            [nzRight]="header.right"
            [class.action-header]="header.name === 'Action'"
          >
            {{ header.name }}
          </th>
          <ng-template #nonSortableHeader>
            <th [nzWidth]="header.width" [nzRight]="header.right" [class.action-header]="header.name === 'Action'">
              {{ header.name }}
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let dashboard of dashboardsTable.data">
        <td>{{ dashboard.name }}</td>
        <td>{{ dashboard?.chartIds?.length }}</td>
        <td>{{ dashboard.lastModifiedAt | dateTime }}</td>
        <td>{{ dashboard.lastModifiedBy }}</td>
        <td nzRight>
          <div class="action-btns">
            <button nz-button nzType="text" (click)="viewDashboard(dashboard)">
              <span nz-icon nzType="eye"></span>
            </button>
            <button nz-button nzType="text" (click)="openEditDashboardModal(dashboard)">
              <span nz-icon nzType="edit"></span>
            </button>
            <button nz-button nzType="text" (click)="deleteDashboard(dashboard)">
              <span nz-icon nzType="delete"></span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <ng-template #noDataTemplate>No Dashboard</ng-template>
</div>
